var envVariables = {
  apiBase: process.env.REACT_APP_API_BASE || 'http://localhost:7500',
  intercom: {
    app_id: process.env.REACT_APP_INTERCOM_APP_ID
  },
  pusher: {
    app_id: process.env.REACT_APP_PUSHER_APP_ID || '1572756',
    key: process.env.REACT_APP_PUSHER_KEY || 'b7de222688ed0328c869',
    secret: process.env.REACT_APP_PUSHER_SECRET || 'f0193b17f230353256eb',
    cluster: process.env.REACT_APP_PUSHER_CLUSTER || 'eu'
  }
};
export default envVariables;